import styled from 'styled-components';

const NativeCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  ${({ size = 16 }) => `width: ${size}px; height: ${size}px; padding: ${Math.round(size/4)}px;`}
`;

export default NativeCheckbox;
